/*
 *
 * website reviews constants
 *
 */

export const FETCH_WEBSITE_REVIEWS = "src/Review/FETCH_REVIEWS";
export const SET_WEBSITE_REVIEWS_LOADING = "src/Review/SET_REVIEWS_LOADING";

